import compose from "@hypnosphi/recompose/compose";
import { withStyles } from "@mui/styles";
import { useState, forwardRef } from "react";
import { useTranslation } from "react-i18next";

import { usePostmongerContext } from "../../contexts/PostmongerContext";

import MenuItem from "apollo-react/components/MenuItem";
import Select from "apollo-react/components/Select";

import Notification from "./OCEPersonal/Notification";
import ToDo from "./OCEPersonal/ToDo";

const styles = {
  section: {
    marginBottom: 32,
  },
};

export const OCEPersonal = (props, ref) => {
  const { t } = useTranslation();

  const { classes } = props;
  const { inArguments, setDirty, disabled } = usePostmongerContext();

  const activityTypeComponents = {
    "Rep Notification": Notification,
    "Rep Todo": ToDo 
  };

  const activityTypeMenuItems = Object.keys(activityTypeComponents).map((v) => {
    return (
      <MenuItem key={v} value={v}>
        {v}
      </MenuItem>
    );
  });

  const defaultActivityType = "Rep Notification";
  const [activityType, setActivityType] = useState(inArguments.get("activityType") || defaultActivityType);

  if (inArguments.get("activityType") != activityType) {
    inArguments.set("activityType", activityType);
  }

  const Tagname = activityTypeComponents[activityType];

  const onActivityTypeSelectChange = (e) => {
    const value = e.target.value;
    setActivityType(value);
    inArguments.set("activityType", value);
    setDirty();
  };

  return (
    <div className={classes.section}>
      <Select
        name="activityType"
        label={t("ocepersonal.activityTypeCaption")}
        value={activityType}
        fullWidth
        required
        canDeselect={false}
        disabled={disabled}
        onChange={onActivityTypeSelectChange}
      >
        {activityTypeMenuItems}
      </Select>
      <>
        <Tagname ref={ref} />
      </>
    </div>
  );
};

export default compose(withStyles(styles))(forwardRef(OCEPersonal));
